/**
 * @typedef {ReturnType<typeof import('widgets/forms/AjaxForm').default>} AjaxForm
 */

/**
 * @param {AjaxForm} AjaxForm Base widget for extending
 * @returns {typeof PasswordResetForm} PasswordResetForm widget
 */
export default function (AjaxForm) {
    /**
     * @category widgets
     * @subcategory account
     * @class PasswordResetForm
     * @augments AjaxForm
     * @classdesc Represents PasswordResetForm component with next features:
     * 1. Allow fire {@link PasswordResetForm#event:submitted} event on success response from backend
     * 3. The main purpose of the widget is emit event that form was successfully submitted
     *
     * PasswordResetDialogForm widget should be a part of {@link PasswordResetModal} widgets that implement modal
     * Widget has next relationship:
     * * PasswordResetForm fire {@link PasswordResetForm#event:submitted} event that {@link PasswordResetModal} listens
     * @property {string} data-widget - Widget name `PasswordResetForm`
     * @example <caption>Example of PasswordResetForm widget usage</caption>
     * <form
     *      class="reset-password-form"
     *      action="${URLUtils.url('Account-PasswordResetDialogForm', 'mobile', pdict.mobile)}"
     *      method="POST"
     *      name="email-form"
     *      id="email-form"
     *      data-widget="passwordResetForm"
     *      data-id="passwordResetForm"
     *      data-event-submit.prevent="handleSubmit"
     *      data-widget-event-submitted="showModal"
     *  >
     *      <div data-ref="errorMessageLabel"></div>
     *      {{^receivedMsgBody}}
     *          <isprint value="${
     *              formElement(pdict.profileForm.resetPassword.email).render()
     *          }" encoding="off"/>
     *          <div class="b-dialog-footer m-actions">
     *              <button
     *                  type="submit"
     *                  class="b-button m-width_full"
     *                  data-widget="button"
     *                  data-widget-event-click="handleSubmit"
     *                  data-event-click.prevent="handleClick"
     *                  data-ref="lastFocusElement"
     *                  data-tau="forgot_password_submit"
     *                  data-id="submitButton"
     *              >
     *                  ${Resource.msg('form.passwordReset.submit','forms',null)}
     *              </button>
     *          </div>
     *      {{/receivedMsgBody}}
     *  </form>
     */
    class PasswordResetForm extends AjaxForm {
        /**
         * @description Handle server response
         * @emits PasswordResetForm#submitted
         * @param {object} data - response data
         * @returns {void}
         */
        onSubmitted(data) {
            if (data.success) {
                /**
                 * @description Event to submitted form
                 * @event PasswordResetForm#submitted
                 */
                this.emitWithoutContext('submitted', data);
            } else {
                super.onSubmitted(data);
            }
        }
    }

    return PasswordResetForm;
}
